"use client";

import Image from "next/image";
import { FaLinkedin, FaInstagram, FaEnvelope } from "react-icons/fa";
// import { Autoplay } from "swiper/modules";

export default function MeetTheTeam() {
  const teamMembers = [
    {
      name: "Mallesh Sunchu",
      role: "Founder, CEO",
      image: "/mallesh.webp",
      linkedin: "https://www.linkedin.com/in/sunchu-mallesh-453472199/recent-activity/all/",
      instagram: "https://www.instagram.com/mallesh_sunchu/",
      // email: "mailto:bingipavankumar63@gmail.com",
    },{
      name: "G.Abhilash Goud",
      role: "Co-Founder, CTO",
      image: "/abhi.webp",
      linkedin: "https://www.linkedin.com/in/abhilash-goud316/recent-activity/all/",
      instagram: "https://www.instagram.com/",
      email: "mailto:abhilashgoud425@gmail.com",
    },
    {
      name: "Kumar Sunchu",
      role: "Advisor",
      image: "/kumar.webp",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    },{
      name: "Raghu Lingala",
      role: "Web Developer",
      image: "/raghu.webp",
      linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      instagram: "https://www.instagram.com/__raghu__1_4/",
      email: "mailto:raghulingala532@gmail.com",
    },{
      name: "RaviTeja Ballikonda",
      role: " Senior Software Developer",
      image: "/ravi.webp",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    },{
      name: "Akhil Kotnal",
      role: "Senior Embedded Developer",
      image: "/akhil.webp",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    
    },{
      name: "Vamshi Sriramoju",
      role: "R&D Trainee",
      image: "/vamshi.webp",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    },{
      name: "Naveen Kumar Pittala",
      role: "R&D Trainee",
      image: "/naveen.webp",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    },{
      name: "Sree Kavya Kulkarni",
      role: "Data Analyst",
      image: "/kavya4.png",
      // linkedin: "https://www.linkedin.com/in/raghu-lingala-/recent-activity/all/",
      // instagram: "https://www.instagram.com/__raghu__1_4/",
      // email: "mailto:raghulingala532@gmail.com",
    },{
      name: "Swathi Mangalarapu",
      role: "Sales Executive",
      image: "/swathi1.png",
      // linkedin: "https://www.linkedin.com/in/pavan-kumar-bingi-7a7a7a2a6/recent-activity/all/",
      // instagram: "https://www.instagram.com/pavan_kumar_bingi_/",
      // email: "mailto:bingipavankumar63@gmail.com",
    }
    ,{
      name: "Uma Pidugu",
      role: "Sales Executive",
      image: "/umaa.webp",
      // linkedin: "https://www.linkedin.com/in/pavan-kumar-bingi-7a7a7a2a6/recent-activity/all/",
      // instagram: "https://www.instagram.com/pavan_kumar_bingi_/",
      // email: "mailto:bingipavankumar63@gmail.com",
    }
    // Add the rest of your team members similarly
  ];

  return (
    <section className="bg-white text-black py-16">
      <div className="container mx-auto px-6 lg:px-20">
        <h2 className="text-4xl sm:text-6xl font-bold mb-6 text-center text-black hover:text-[#6BAF92]">Meet Our Team</h2>
        <p className="text-center text-lg mb-12 text-[#4c4c4c]">
          Meet the extraordinary individuals driving Para Innovations forward. 
          Our team is committed to revolutionizing the agricultural and industrial 
          sectors with passion, innovation, and expertise.
        </p>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-lg bg-[#6BAF92]"
            >
              {/* Team Member Image */}
              <Image
                src={member.image}
                alt={member.name}
                width={500}
                height={500}
                className="w-full aspect-square object-cover transition duration-300 group-hover:grayscale"
              />

              {/* Overlay with Social Icons */}
              <div className="absolute inset-0 bg-black/20 bg-opacity-60 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div className="flex space-x-4">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-2xl hover:text-blue-400"
                  >
                    <FaLinkedin />
                  </a>
                  <a
                    href={member.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-2xl hover:text-pink-400"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href={member.email}
                    className="text-white text-2xl hover:text-red-400"
                  >
                    <FaEnvelope />
                  </a>
                </div>
              </div>
              {/* Team Member Info */}
              <div className="text-center mt-4">
                <h3 className="text-xl font-semibold text-white">{member.name}</h3>
                <p className="text-white">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}